import { styled as muiStyled } from '@mui/material'

export const CreateRecommendationsContainer = muiStyled('div')(
  ({ theme, showRedBorder = false }) =>
    `
    background: white;
    border: 2px solid ${showRedBorder ? '#fcdd00' : '#c4b5fd'};
    border-radius: 16px;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .04);
`,
)

export const RecommendationItemContainer = muiStyled('div')(
  ({ theme }) => `
  border: 1px solid #c4b5fd;
  border-radius: 12px;
  padding: 8px 16px;
`,
)
